import { TileCoordinates, TileHoverContextProvider } from 'app/src/editor/TileHoverContext';
import * as React from 'react';

type Props = {
	children: React.ReactNode;
};

export default function TileHoverController({ children }: Props): React.ReactElement {
	const [coords, setCoords] = React.useState<TileCoordinates | null>(null);

	const setTileCoordinates = (newCoords: TileCoordinates | null): void => {
		setCoords(newCoords ? { ...newCoords } : null);
	};

	return (
		<TileHoverContextProvider
			value={{
				coords,
				setTileCoordinates,
			}}
		>
			{children}
		</TileHoverContextProvider>
	);
}
